export enum DefaultElementDefinitions {
  Requestor = 'Default - Requestor',
}
